var version = "4.8.0";
export { version as default };
//# sourceMappingURL=Version.js.map
